/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".doctorReport_header[_ngcontent-%COMP%]{text-align:left;background-color:#f5f5f5;color:#004aad;font-size:14px;font-weight:700;opacity:1}.doctorReport_content[_ngcontent-%COMP%]{white-space:pre-line}.doctorReport_content[_ngcontent-%COMP%], .text-style[_ngcontent-%COMP%]{text-align:left;font-size:14px}@media screen{#print-content[_ngcontent-%COMP%], .print-content[_ngcontent-%COMP%]{display:none!important;visibility:hidden!important}}html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

